import type { GatsbyBrowser } from "gatsby";

import Layout from "./src/components/layout";

export const wrapPageElement: GatsbyBrowser["wrapPageElement"] = ({
  element,
  props,
}) => <Layout location={props.location}>{element}</Layout>;
